// axios
import axios from 'axios';

const baseURL = '';
const headers = {
  Accept: 'application/json',
};
const token = localStorage.getItem('token');
if (token && token.length > 0) {
  headers['Authorization'] = 'Bearer ' + token;
}
export default axios.create({
  baseURL,
  headers,
  // You can add your headers here
});
